define('businessServices/router/authorizationPlugins/signupForCustomerAuthorizationPlugin',[
    'businessServices/authentication/signupForCustomerManager',
    'common/promises/promiseFactory'
], function() {
    function performImpersonation(impersonationNonceId, affiliateId, hubSpotContactRecordId, patliveAccountNumber) {
        var PromiseFactoryConstructor = require('common/promises/promiseFactory');
        var promiseFactory = new PromiseFactoryConstructor();
        return promiseFactory.defer(function(promise) {
            var signupForCustomerManager = require('businessServices/authentication/signupForCustomerManager');
            signupForCustomerManager.signupForCustomerWithImpersonationNonce(impersonationNonceId, affiliateId, hubSpotContactRecordId, patliveAccountNumber)
                .done(function(result) {
                    if (result.isSuccess) {
                        promise.resolve({status : "success"});
                    } else {
                        promise.resolve({status : "failed"});
                    }
                })
                .fail(function(error) {
                    promise.reject(error);
                });
        });
    }

    function signupForCustomerAuthorization(fragment) {
        if (fragment.startsWith("signupForCustomer/") === false) {
            return { status : "ignored" };
        }

        let [url, impersonationNonce, affiliateId, hubSpotContactRecordId, patliveAccountNumber] = fragment.split('/');

        if (affiliateId === "undefined") {
            affiliateId = null;
        }

        if (hubSpotContactRecordId === "undefined") {
            hubSpotContactRecordId = null;
        }

        if (patliveAccountNumber === "undefined") {
            patliveAccountNumber = null;
        }

        return performImpersonation(impersonationNonce, affiliateId, hubSpotContactRecordId, patliveAccountNumber);
    }

    return {
        configureAuthorization : signupForCustomerAuthorization
    };
});
